module.exports = function getRoot( absolute, folders, filename, sep ) {
	return absolute ? sep : ''
}
